import { errorHandler } from '../../helpers';
export default ((store, api, sharedActions) => {
  const setUserEmailPolicyState = payload => {
    Object.assign(store.auth.userEmailPolicyState, payload);
  };
  const loadUserEmailPolicyState = async () => {
    setUserEmailPolicyState({
      loading: true
    });
    try {
      const userEmailPolicyConfig = await api.userEmailPolicy.getUserEmailPolicyConfig();
      setUserEmailPolicyState({
        loading: false,
        userEmailPolicyConfig
      });
    } catch (e) {
      setUserEmailPolicyState({
        loading: false,
        error: errorHandler(e)
      });
    }
  };
  return {
    loadUserEmailPolicyState,
    setUserEmailPolicyState
  };
});